import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RCSlider from 'rc-slider';
// import ErrorMessage from '../ErrorMessage';
import {
  Title,
  TitleWrap,
  Label,
  SliderSection,
  SliderContainer,
  LabelRow,
  MinMaxLabelRow,
} from './Slider.styles';

interface SliderProps {
  min: number;
  max: number;
  dots?: boolean;
  stepSize: number;
  value: number;
  onChange: (newValue: number) => void;
  title: string;
  valueLabelGetter?: (numericValue: number) => string;
  error?: string;
  disabled?: boolean;
}

const defaultVaueLabelGetter = (value: number): string => String(value);

const Slider: React.FC<SliderProps> = ({
  value,
  onChange,
  valueLabelGetter = defaultVaueLabelGetter,
  title,
  min,
  max,
  stepSize,
  dots,
  error,
  disabled,
}) => {
  const { t } = useTranslation();
  const [temporaryValue, setTemporaryValue] = useState<number>(value);

  useEffect(() => {
    setTemporaryValue(value);
  }, [value]);

  return (
    <SliderSection>
      <TitleWrap>
        <Title disabled={disabled}>{title}</Title>
      </TitleWrap>
      <SliderContainer data-testid="radius-slider">
        <LabelRow>
          <Label disabled={disabled} data-testid="radius-slider-temporary-value">
            {valueLabelGetter(temporaryValue)}
          </Label>
        </LabelRow>
        <RCSlider
          min={min}
          max={max}
          value={temporaryValue}
          step={stepSize}
          ariaValueTextFormatterForHandle={(v: number) => valueLabelGetter(v)}
          ariaLabelForHandle={t('dealerLocationSearch.slider.ariaLabelValue', {
            title,
            value: temporaryValue,
          })}
          onChange={(v) => setTemporaryValue(v as number)}
          onAfterChange={(v) => {
            onChange(v as number);
            setTemporaryValue(v as number);
          }}
          dots={dots}
          disabled={disabled}
        />
      </SliderContainer>
      <MinMaxLabelRow>
        <div data-testid="radius-slider-minimum-value">{valueLabelGetter(min)}</div>
        <div data-testid="radius-slider-maximum-value">{valueLabelGetter(max)}</div>
      </MinMaxLabelRow>
      {/* <ErrorMessage error={error} /> */}
    </SliderSection>
  );
};

Slider.defaultProps = {
  valueLabelGetter: undefined,
  dots: undefined,
};

export default Slider;
